import React from 'react'
import moment from 'moment-timezone'
import classNames from 'classnames'
import { useRouter, useSearchParams } from 'next/navigation'
import { Route } from 'next'
import styles from './EventTickets.module.css'
import { addDateToQuery } from '@/utils/components/EventTickets.utils'
import { PartialModalState } from '@/types/ModalProvider.types'
import { TIME_FORMATS } from '@/config/dates.config'
import { useSeller } from '@/app/_providers/SellerProvider/SellerProvider'

type Props = {
  session: Transformed.Timeslot | { id: string; startTime: string },
  incomingDate: string | null,
  updateModalState: (nextState: PartialModalState) => void
}

const {
  calendarDate,
  dayTile,
} = TIME_FORMATS
const DayTile: React.FunctionComponent<Props> = ({
  session,
  incomingDate,
  updateModalState,
}: Props) => {
  const router = useRouter()
  const { timezone } = useSeller()
  const searchParams = useSearchParams()

  const handleClick = (): void => {
    // use router to set date query param in YYYY_MM_DD format
    const formattedDate = moment(session.startTime)
      .tz(timezone)
      .format(calendarDate)
    // only update query if date is different from current
    if (incomingDate !== formattedDate) {
      const nextRoute = addDateToQuery(formattedDate, searchParams)
      router.push(nextRoute as Route, { scroll: false })
    }
    updateModalState({ open: { eventDetails: false } })
  }

  const isSelected = moment(session.startTime)
    .tz(timezone)
    .format(calendarDate) === incomingDate

  return (
    <button
      type="button"
      className={classNames(
        styles.DayTile,
        { [styles.Selected]: isSelected },
      )}
      data-testid="recurring-event-day"
      onClick={handleClick}
    >
      {moment(session.startTime)
        .tz(timezone)
        .format(dayTile)}
    </button>
  )
}

export default DayTile
